import React, { useState, useEffect, useRef } from 'react';
import './searchBox.css';
import PropTypes from 'prop-types';
import SearchIcon from '../../Assets/Icons/Search.png'
import Icons from '../../Assets/Icons'
import { useTranslation } from 'react-i18next';

const SearchBox = ({ onSearch, placeholder, value }) => {
  const [query, setQuery] = useState(value ?? undefined);
  const onSearchRef = useRef(onSearch);

  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  useEffect(() => {
    if (value !== undefined) setQuery(value);
  }, [value]);
  
  useEffect(() => {
    if (query === undefined) return;
    const trimmed = (query || "").trim();
    const timer = setTimeout(() => {
      onSearchRef.current(trimmed);
    }, trimmed.length > 1 ? 300 : 0);
    return () => clearTimeout(timer);
  }, [query]);

  const { t } = useTranslation();

  const handleInputChange = (e) => {
    setQuery(e.target.value.trimStart().slice(0, 100));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearch = () => {
    if(query !== undefined){
      onSearchRef.current(query.trim());
    }
  };


  SearchBox.propTypes = {
    placeholder: PropTypes.string,
  };
  

  return (
    <div className="search-box">
      <div className="icon-search">
      <img src={SearchIcon} alt="Search Icon" className='search-icon' />
      </div>
      <input
        type="text"
        value={query}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        placeholder={t(placeholder)}
        className="search-input"
      />
       {query && <div className="icon-cross">
      <img src={Icons.cross} alt="Search Icon" className='cross-img'  onClick={()=>{setQuery('')}}/>
      </div>}
    </div>
  );
};

export default SearchBox;
